import React, { useEffect } from "react";
import "./App.scss";
import Main from "./containers/Main";
import { analytics } from "./firebaseConfig";
import { logEvent } from "firebase/analytics";

function App() {
  useEffect(() => {
    // Log a custom event when the page loads
    logEvent(analytics, "page_view", { page_title: "Home Page" });
  }, []);

  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
